import $store from '@/store'
import { APP_API_URL, APP_API_SALON_URL, APP_ORGANISATION, APP_ENVIRONMENT } from '@/utils/types/setting'
import { ENVIRONMENT } from '@/utils/constants'

const organisation = {
    name: 'Lab\'o',
    logo: `/static/img/organisations/labo/logo.png`,
    logoLogin: `/static/img/organisations/labo/logo-login.png`,
    logoMobile: `/static/img/organisations/labo/logo-login.png`,
    background: `/static/img/organisations/labo/background.jpg`
}

export default () => {
    $store.commit('base/setting/update', { key: APP_API_URL, value: 'https://clara.alterego-digital.eu/v1' })
    $store.commit('base/setting/update', {key: APP_API_SALON_URL, value: 'https://api-salon.alterego-digital.com/v1/external'})
    $store.commit('base/setting/update', { key: APP_ORGANISATION, value: organisation })
    $store.commit('base/setting/update', { key: APP_ENVIRONMENT, value: ENVIRONMENT.PRE_PROD })
}
